import { createSelector } from 'reselect';

function resolveNestedPath(path, obj = {}, separator = '.') {
  const properties = Array.isArray(path) ? path : path.split(separator);
  return properties.reduce((prev, curr) => prev[curr], obj);
}

const makeSelectReducerState = (stateMap, pageReducer) =>
  createSelector(
    () => stateMap.get(pageReducer, {}),
    substate => substate.toJS(),
  );

export function extractDirectStateFromReduxStore(store = {}, statePath) {
  const statePathPoints = statePath.split('.').map(x => x.trim());

  const pageReducer = statePathPoints.shift();

  const reducerState = makeSelectReducerState(
    new Map(store.getState()),
    pageReducer,
  )();

  let result = reducerState;
  if (statePathPoints.length > 0) {
    result = resolveNestedPath(statePathPoints, reducerState);
  }

  return result;
}
